"use client"

import { useEffect, useState } from "react"

/**
 * Returns a value that only updates `delayMs` after the input stops
 * changing. Cleans up the pending timer on unmount and on fast
 * successive changes.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const handle = setTimeout(() => setDebounced(value), delayMs)
    return () => clearTimeout(handle)
  }, [value, delayMs])

  return debounced
}
